'use strict';

module Patersons {

    export class BannerService extends BaseService {

        getCurrent(): ng.IHttpPromise<any> {
            return this.get("/dataService/odata/banners?$filter=publishDate lt " + new Date().toJSON() + "&$orderby=publishDate desc&$top=1");
        }
    }
}